export default {
    pageTitle: 'Tableau de bord',
    noAvailableType: 'Aucun type de licence valide pour cette plateforme',
    name: 'Tableau de bord',
};
